/**
 * planResumeLink.ts — the clinician/admin plan→pay handoff URL.
 *
 * Same shape clinic-service emails after Authorise→Recommend
 * (`${PORTAL_BASE_URL}/weightloss#resume=<assessmentId>`). Fragment, not
 * query: the assessment id must not land in access logs / Referer / GTM
 * `page_location` (see `journey/resumeHandoff.ts`).
 *
 * No send-time clock TTL — the id stays usable until the assessment is no
 * longer checkoutable. Admin "Copy payment link" must mint this exact form.
 *
 * WHERE THE LINK POINTS (Clinics-in-Core, 2026-09-07). The journey lives at the
 * portal's own front door. When this build is served standalone that is its own
 * origin (+ any basename); when GPS Core fronts the portal under /clinics/*, the
 * acquisition journey is NOT served there (it redirects to the standalone
 * portal), so a link minted from inside Core must point straight at the
 * standalone origin — otherwise a patient would land on a Core host to be
 * bounced. `journeyBase()` resolves that in one place (config.ts).
 */
import { journeyBase } from '../config';

/** Absolute `#resume=` URL for clipboard / paste into SMS or email. */
export function planResumeUrl(assessmentId: string, base: string = journeyBase()): string {
  return `${base}/weightloss#resume=${encodeURIComponent(assessmentId)}`;
}
